import logo from './logo.svg';
import './App.css';

import React, { useState } from 'react';
import './App.css';

// Define the grid for the 404 (26x12 for a classic look)
const ROWS = 12;
const COLS = 26;
// Coordinates for green clue pixels (row, col)
const CLUE_PIXELS = {
  '2-6': 'Clue 1: Try clicking the next green pixel!',
  '4-12': 'Clue 2: The answer is hidden in plain sight.',
  '7-19': 'Clue 3: You are getting closer!',
  '9-21': 'Clue 4: answer all quizes below and you will be not gay!',
};

function App() {
  const [clue, setClue] = useState(null);

  // Generate the pixel grid
  const grid = [];
  for (let row = 0; row < ROWS; row++) {
    const rowPixels = [];
    for (let col = 0; col < COLS; col++) {
      // Draw the shape of a big '404' with pixels
      let isPixel = false;
      let isClue = false;
      let color = '#222';

      // --- Draw first '4' ---
      // Left vertical bar
      if (col === 3 && row >= 2 && row <= 9) isPixel = true;
      // Middle horizontal bar
      if (row === 6 && col >= 1 && col <= 7) isPixel = true;
      // Right vertical bar (top half)
      if (col === 7 && row >= 2 && row <= 6) isPixel = true;

      // --- Draw '0' ---
      // Left side
      if (col === 12 && row >= 2 && row <= 9) isPixel = true;
      // Right side
      if (col === 18 && row >= 2 && row <= 9) isPixel = true;
      // Top bar
      if (row === 2 && col >= 12 && col <= 18) isPixel = true;
      // Bottom bar
      if (row === 9 && col >= 12 && col <= 18) isPixel = true;

      // --- Draw second '4' ---
      // Left vertical bar
      if (col === 21 && row >= 2 && row <= 9) isPixel = true;
      // Middle horizontal bar
      if (row === 6 && col >= 21 && col <= 25) isPixel = true;
      // Right vertical bar (top half)
      if (col === 25 && row >= 2 && row <= 6) isPixel = true;

      // Clue pixels
      if (CLUE_PIXELS[`${row}-${col}`]) {
        isClue = true;
        color = 'green';
      } else if (isPixel) {
        color = 'white';
      }
      rowPixels.push(
        <div
          key={`${row}-${col}`}
          className={`pixel${isClue ? ' clue' : ''}`}
          style={{ background: color, cursor: isClue ? 'pointer' : 'default' }}
          onClick={() => isClue && setClue(CLUE_PIXELS[`${row}-${col}`])}
        ></div>
      );
    }
    grid.push(
      <div className="pixel-row" key={row}>
        {rowPixels}
      </div>
    );
  }

  return (
    <div className="App">
      {/* Social and contract section at the top */}
      <div className="social-section">
        <a className="social-icon" href="https://x.com/404E" target="_blank" rel="noopener noreferrer" title="Twitter">
          <img src={process.env.PUBLIC_URL + '/twitter.svg'} alt="Twitter" />
        </a>
        <a className="social-icon" href="https://dexscreener.com/solana/er5je4yftfasdv6jlyvxw6pz3hka4gzkvnkph1zchubc" target="_blank" rel="noopener noreferrer" title="Dexscreener">
          <img src={process.env.PUBLIC_URL + '/dex.svg'} alt="Dexscreener" />
        </a>
        <div className="contract-address">
          <span>Contract Address: 5tGFt1UN86JHHchD4VjgBESJ1pWRp3AkazCAkii8pump</span> <span className="ca-value">TBA</span>
        </div>
      </div>
      <h1 className="giant-404-title">404 Error</h1>
      <div className="pixel-grid">{grid}</div>
      {clue && (
        <div className="clue-modal" onClick={() => setClue(null)}>
          <div className="clue-content">{clue}<br /><span className="clue-close">(Click anywhere to close)</span></div>
        </div>
      )}
      <div className="subtitle">Not Found? Or is it?</div>

      {/* Carousel headline */}
      <h2 className="carousel-headline">404 isn&apos;t an error.. it&apos;s an invitation</h2>
      <CarouselWithQuiz />

      {/* Social and contract section */}
      <div className="social-section">
        <a className="social-icon" href="https://x.com/404E" target="_blank" rel="noopener noreferrer" title="Twitter">
          <img src={process.env.PUBLIC_URL + '/twitter.svg'} alt="Twitter" />
        </a>
        <a className="social-icon" href="https://dexscreener.com" target="_blank" rel="noopener noreferrer" title="Dexscreener">
          <img src={process.env.PUBLIC_URL + '/dex.svg'} alt="Dexscreener" />
        </a>
        <div className="contract-address">
          <span>Contract Address:</span> <span className="ca-value">TBA</span>
        </div>
      </div>
    </div>
  );
}

// Simple image carousel component
// Carousel context for quiz sync
const CarouselContext = React.createContext();

function CarouselWithQuiz() {
  const images = [
    'ds.png',
    'os.png',
    'me.png',
    'cmc.png',
  ];
  const [idx, setIdx] = React.useState(0);
  const prev = () => setIdx((i) => (i === 0 ? images.length - 1 : i - 1));
  const next = () => setIdx((i) => (i === images.length - 1 ? 0 : i + 1));
  return (
    <CarouselContext.Provider value={{ idx, image: images[idx], setIdx, images }}>
      <div>
        <div className="carousel-container">
          <button className="carousel-btn" onClick={prev}>&lt;</button>
          <img
            src={process.env.PUBLIC_URL + '/' + images[idx]}
            alt={`carousel ${idx + 1}`}
            className="carousel-img"
          />
          <button className="carousel-btn" onClick={next}>&gt;</button>
        </div>
        <QuizField />
      </div>
    </CarouselContext.Provider>
  );
}

function QuizField() {
  const quizAnswers = {
    'ds.png': 'dex screener',
    'os.png': 'opensea',
    'me.png': 'magic eden',
    'cmc.png': 'coin market cap',
  };
  const { image } = React.useContext(CarouselContext) || {};
  const [input, setInput] = React.useState('');
  const [result, setResult] = React.useState(null);

  React.useEffect(() => {
    setInput('');
    setResult(null);
  }, [image]);

  if (!image) return null;
  // Always show quiz field for these images


  const handleSubmit = (e) => {
    e.preventDefault();
    const answer = quizAnswers[image].toLowerCase().replace(/\s+/g, '');
    const guess = input.toLowerCase().replace(/\s+/g, '');
    setResult(guess === answer ? 'correct' : 'incorrect');
  };

  return (
    <form className="quiz-field" onSubmit={handleSubmit} autoComplete="off">
      <input
        type="text"
        className="quiz-input"
        placeholder="Which website is this?"
        value={input}
        onChange={e => setInput(e.target.value)}
      />
      <button className="quiz-submit" type="submit">Guess</button>
      {result && (
        <span className={`quiz-result ${result}`}>{result === 'correct' ? 'Correct!' : 'Try again!'}</span>
      )}
    </form>
  );
}


export default App;
